import { useEffect, useState } from "react";
import dayjs from "dayjs";

const useCountDown = ({ value, base, onFinish }) => {
  let timer = null;
  const [now, setNow] = useState(
    base ? dayjs(base).millisecond() : +new Date()
  );
  const [day, setDay] = useState("00");
  const [hour, setHour] = useState("00");
  const [min, setMin] = useState("00");
  const [sec, setSec] = useState("00");

  useEffect(() => {
    const subD = dayjs.duration(
      new Date(value).getTime() - new Date(now).getTime()
    );
    if (subD.months() > 0) {
      const months = subD.months();
      let days = 0;
      for (let i=1; i<=months; i++) {
        days += dayjs().add(i, 'month').daysInMonth();
      }
      setDay((subD.days() + days).toString().padStart(2, '0'));
    } else {
      setDay(subD.days().toString().padStart(2, "0"));
    }
    setHour(subD.hours().toString().padStart(2, "0"));
    setMin(subD.minutes().toString().padStart(2, "0"));
    setSec(subD.seconds().toString().padStart(2, "0"));

    timer = setTimeout(() => {
      const n = +new Date();
      if (new Date(value).getTime() - n > 0) {
        setNow(+new Date());
      } else {
        if (onFinish) {
          onFinish();
        }
        timer = null;
      }
    }, 1000);

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [value, now]);

  return {
    day,
    hour,
    min,
    sec,
  };
};

export default useCountDown;
